/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import CopyToClipboard from "react-copy-to-clipboard";
import { When, If, Then, Else } from "react-if";
import { Link } from "react-router-dom";
import { FlexContainer, SVGIcon, Text, theme } from "@nordcloud/gnui";
import { ConditionalWrap } from "~/components/Utils";
import { SUCCESS_TEXT } from "~/constants";
import { showSimpleInfo } from "~/services/toast";
import { isNotEmpty, trimTextBeginning } from "~/tools";

type Props = {
  name: string;
  url?: string;
  descriptionUrl?: string;
  description?: string;
  trim?: number;
  copy?: boolean;
};

export function CustomCell({
  name,
  url,
  description,
  trim = 100,
  descriptionUrl = "",
  copy = false,
}: Props) {
  return (
    <>
      <FlexContainer>
        <If condition={url !== undefined}>
          <Then>
            <Link to={url || ""}>{trimTextBeginning(name, trim)}</Link>
          </Then>
          <Else>{trimTextBeginning(name, trim)}</Else>
        </If>
        <When condition={copy}>
          <CopyToClipboard
            text={name}
            onCopy={() => {
              showSimpleInfo(SUCCESS_TEXT.copied);
            }}
          >
            <SVGIcon
              name="copy"
              size="sm"
              css={{ cursor: "pointer", marginLeft: theme.spacing.spacing02 }}
            />
          </CopyToClipboard>
        </When>
      </FlexContainer>
      <When condition={description !== undefined}>
        <FlexContainer>
          <Text size="sm" tag="span" color={theme.color.text.text02}>
            <ConditionalWrap
              condition={isNotEmpty(descriptionUrl)}
              wrap={(children) => <Link to={descriptionUrl}>{children}</Link>}
            >
              <>{trimTextBeginning(description, trim)}</>
            </ConditionalWrap>
          </Text>
        </FlexContainer>
      </When>
    </>
  );
}
